import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { IssuesWithTheARVSystem } from "../utils/constants";

const Assessment_Collection_Unit_Area_Assessment = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1 min-height-800">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu   min-height-400">
                <nav className="sidebar card py-2 mb-4">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <Link
                        className="nav-link fontSizeClass active1"
                        to="/Assessment_Collection_Unit_Area_Assessment"
                      >
                        {t("A Brief Summary")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18016526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t("Mayor's Appeal")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"3ad2cd96-cee9-4b99-b65b-b309b0f0477d"}&tenantId=km.kolkata`}
                      >
                        {t("Scheme for Unit Area Assessment")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18016626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t("Brief Synopsis of Unit Area Assessment System")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"c1d1c62f-d757-4911-ad93-2489b69f49fc"}&tenantId=km.kolkata`}
                      >
                        {t("Final Notification (Block & Categorization)")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18016726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t(
                          "Kolkata Municipal Corporation(Self Assessment System,Manner and Forms)Rules 2017"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18016826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t(
                          "Kolkata Municipal Corporation(Covered Space)Regulations 2017"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18016926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t(
                          "Kolkata Municipal Corporation(Unit Area Assessment - Tax Capping)Regulation 2017"
                        )}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"f83ee1a8-f6d2-4afd-8821-6bc03ad5bbf3"}&tenantId=km.kolkata`}
                      >
                        {t("Downloadable SAF Forms")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18017026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                      >
                        {t(
                          "List of Self Assessment Return Preparer under Unit Area Assessment(UAA)"
                        )}
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="container">
                <div class="row">
                  <div class="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Unit Area Assessment System: A Synopsis")}
                    </h3>
                  </div>
                  <p className="clor3">
                    <a
                      href="https://youtu.be/jXSBQiCsavs?si=1oPi2DNTtBW5B10S"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      How to do self assessment
                      <i class="bi bi-chevron-right"></i>
                    </a>
                  </p>
                  <div class="col-lg-12 about-head1">
                    <div class="unit-area-assessment para_text">
                      <p className="fontSizeClass">
                        <b>
                          {t(
                            "‘Annual Rateable Value’ (ARV) system of property taxation prevalent prior to Publication of scheme for Unit Area Assessment System on 1st April, 2017"
                          )}
                          :-:
                        </b>
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "The ARV system of property taxation is based on the principle of Annual Rateable Value method. The Annual Valuation (AV) of the property is determined after deducting 10% on account of maintenance and repair from the actual annual rent realized from the property or the annual reasonable rent which the property might have fetched from year to year had it been let out"
                        )}
                        .
                      </p>
                      <p className="fontSizeClass">
                        {t(
                          "The tax rate, under the said system, increases proportionately with the gradual increase of individual AV of the property and is calculated using a somewhat complex formula. It varies from 11% to 40%. However for ordinary flats the rate of tax of individual flat depends on cumulative AV of all flats in the premises. There is also provision of 50% commercial surcharge if the property is being used for commercial activities"
                        )}
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container mb-5">
            <div className="row para_text">
              <div className="col-md-12 about-head1">
                <p className="fontSizeClass">
                  <b>{t("Issues with the ARV system")}:</b>
                </p>
                {IssuesWithTheARVSystem.map((issue, index) => (
                  <p
                    className="fontSizeClass"
                    style={{ display: "block" }}
                    key={index}
                  >
                    {index + 1}. {t(issue)}.
                  </p>
                ))}
              </div>
            </div>
            <div className="row my-5">
              <div class="col-lg-6">
                <p className="fontSizeClass">
                  <b>
                    {t(
                      "Unit Area Assessment (UAA) system of property taxation :"
                    )}
                    :
                  </b>
                </p>
                <div class="col-lg-12 about-head1 para_text">
                  <p className="fontSizeClass">
                    {t(
                      "To get rid of inherent problems in ARV system different Urban Local Bodies of India have undertaken exercise for introduction of Area Based Property Tax system under different names. Here in Kolkata it is called Unit Area Assessment System. Scheme for UAA System has been published in Official Gazette on 1st April, 2017 and this system is at present commenced in ward No.001 to 141 from that day. However, all pending assessment for the effective quarter / period prior to 1st April, 2017 will be done as per ARV method. From 1st quarter 2017, all properties are required to be reassessed under new (UAA) system. Till fresh valuation is determined and enforced in UAA System, tax payers are required to continue making payment of yearly P.D. / Fresh-Supplementary bill sent to them against demand under ARV system"
                    )}
                    .
                  </p>
                  <p className="fontSizeClass">
                    {t(
                      "The entire city is divided into 293 blocks and these blocks are classified into seven categories (A to G) on the basis of market value, infrastructure, facilities etc. Corresponding to each category, (viz. A,B,C,D,E,F,G) an Annual value / sq.ft. i.e. Base Unit Area Value (BUAV) is assigned, category 'A' having the highest BUAV while 'G' having the lowest BUAV. It ensures equity at the macro level of the properties lying within the same block or similar category block. However, in order to remove hardship, bustee / slum / thika-tenanted area are categorized as 'G', for the purpose of assessment, irrespective of their geographical location under any block or category. Similarly, all recognized RR colonies including settlements under Govt. notified EWS and BSUP Schemes have been categorized as 'E' irrespective of their geographical situation under any block or category unless these belong to a block whose category is lower than that of 'E'"
                    )}
                    .
                  </p>

                  <p className="fontSizeClass">
                    {t(
                      "To account for the wide heterogeneity among properties within a block, Multiplicative Factors (MFs) are introduced. MFs would account for variations in terms of purpose of use, age of the property, location of the property within the block, nature of occupancy and type of structure, which are clearly notified and used to increase or decrease Base Unit Area Values of different properties as applicable or to keep it same"
                    )}
                    .
                  </p>

                  <p className="fontSizeClass">
                    {t(
                      "As opposed to the ARV system, a flat tax rate percentage within min-max limit of 6% to 20% is applied and notified in the UAA system. Already tax rate for developed bustee is fixed at 8%. Also, in this system, rate of tax of individual flat will not depend on cumulative AV of all flats in the premises concerned"
                    )}
                    .
                  </p>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="col-lg-12 about-head1 para_text">
                  <p className="fontSizeClass">
                    {t(
                      "To determine such divisions of blocks with different categories, concerned BUAV, MF values, Tax rate etc. a Municipal Valuation Committee was formed which was constituted by experts from different fields of the society. Similarly an Anomaly Review Committee was formed to consider citizen's feedback towards such categorization. Such categories and values will be revisited once in five year"
                    )}
                    .
                  </p>
                  <p className="fontSizeClass">
                    {t(
                      "Before finally fixing the block division and categories, a draft notification was published in official Gazette inviting suggestions and objections from the citizens. This facility was similarly extended to the citizens while fixing category wise Base Unit Area Value(s) of properties"
                    )}
                    .
                  </p>
                  <p className="fontSizeClass">
                    {t(
                      "Assessment of property tax can be done by the assessee himself as opposed to the ARV system where only assessment inspectors were responsible for assessment. All parameters for calculating property tax in UAA system have, therefore, been notified clearly for the information of the rate payers in Scheme which is available at different offices of the Assessment-Collection Department and website of Kolkata Municipal Corporation. Return in Self-Assessment form is required to be submitted within sixty days from date of publication of Scheme collecting the same from offices of Assessment-Collection Department or website and the same may be submitted offline or online"
                    )}
                    .
                  </p>
                  <p className="fontSizeClass">
                    {t(
                      "It is envisioned that the UAA system would be non-discretionary, transparent, equitable, easy to administer and the citizens will thereby be empowered by providing opportunities for self assessment"
                    )}
                    .
                  </p>
                  <p className="fontSizeClass">
                    <b>
                      {t(
                        "Annual Property Tax under the UAA system is calculated on the basis of the following formula"
                      )}
                      :
                    </b>
                  </p>
                  <p className="fontSizeClass">
                    <b>
                      {t(
                        "Annual Tax = [BUAV] x [Covered Space/Land Area] x [Age MF Value] x [Structure MF Value] x [Usage MF Value] x [Location MF Value] x [Occupancy MF Value] x [Rate of Tax (including HB Tax)]"
                      )}
                      .
                    </b>
                  </p>
                  <p className="fontSizeClass">
                    <b>
                      {t(
                        "For Base Unit Area Values and MF Values please go to the section ‘Scheme’. Tax Capping is a provision of the Act and this is not a temporary measure"
                      )}
                      .
                    </b>
                  </p>
                  <p className="fontSizeClass">
                    <b>
                      {t(
                        "For further detail please go to the Section “Brief Account of the Unit Area Assessment System” and refer to relevant pages of ‘Scheme’, ‘Regulation for Covered Space’ , ‘Tax Capping’ and Rule for ‘Self-Assessment System Manner & Forms.'"
                      )}
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Assessment_Collection_Unit_Area_Assessment;
